export default "__VITE_ASSET__BLMfZUyq__"